export default __webpack_public_path__ + "img/bg-tab1and2_nav7-8fcd3f0b.png";